import { RequestParams, RequestQueryOptions } from '@approvalmax/data';
import { useGet } from 'shared/data/api';

import { referencesApiPaths } from '../paths';
import { GetPersonDocumentTypes } from './useGetPersonDocumentTypes.types';

export const useGetPersonDocumentTypes = (
    params?: RequestParams<GetPersonDocumentTypes>,
    queryOptions?: RequestQueryOptions<GetPersonDocumentTypes>
) => {
    return useGet(referencesApiPaths.personDocumentTypes, {
        params,
        queryOptions: {
            // we don't expect any changes of reference data from BE side
            staleTime: Infinity,
            ...queryOptions,
        },
        apiSource: 'walletsKyc',
        apiVersion: 'v1',
    });
};
